// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sized":"_2ulGkX","textAligned":"ymgDF0"};